// extracted by mini-css-extract-plugin
export var available = "styles-module--available--oWInt";
export var col = "styles-module--col--iZcfi";
export var component = "styles-module--component--Ex2IX";
export var inner = "styles-module--inner--2RMRr";
export var productAnim = "styles-module--product-anim--sWF1C";